import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formRow: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 20,
      gap: 20,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    logoPartnerContainer: {
      width: '100%',
      textAlign: 'center',
      marginTop: theme.spacing(1),
    },
    paymentError: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      padding: '20px 0',
      color: theme.oysterTheme.ferrari,
      '& .MuiSvgIcon-root': {
        marginRight: 10,
      },
    },
  }),
);

export default useStyles;
